import {Map} from "@luciad/ria/view/Map";
import {TileSetAttributionProvider} from "@luciad/ria/view/tileset/TileSetAttributionProvider";
import React, {ReactNode, useEffect, useState} from "react";
import "./Attribution.css";

interface Props {
  map: Map;
  staticAttributions?: ReactNode;
}

//#snippet attribution
export const Attribution = ({map, staticAttributions}: Props) => {

  const [logos, setLogos] = useState<string[]>([]);
  const [strings, setStrings] = useState<string[]>([]);

  useEffect(() => {
    const attributionProvider = new TileSetAttributionProvider(map);

    const attributionLogosListener = attributionProvider.on("AttributionLogosChanged", () => {
      setLogos(attributionProvider.getAttributionLogos());
    });
    const attributionStringsListener = attributionProvider.on("AttributionStringsChanged", () => {
      setStrings(attributionProvider.getAttributionStrings());
    });

    return () => {
      attributionLogosListener.remove();
      attributionStringsListener.remove();
    }
  }, [map]);

  return (
      <div className="attribution">
        {logos.map(logo => <img alt={logo} key={logo} className="attributionLogo" src={logo}/>)}
        <div className="attribution-strings">
          {[...strings].map(str => <p key={str}>{str}</p>)}
          {staticAttributions}
        </div>
      </div>
  )
}
//#endsnippet attribution
